import { Windows95Window } from "../Windows95Window";
import { IWindowState } from "../../Types/IWindowState";
import { IContactStatus } from "../../Types/IContactStatus";
import { ContactIDtoString } from "../../Constants/ContactIDtoString";
import { Container, Graphics, NineSlicePlane, Text, TextStyle } from "pixi.js";
import { FileEditHelpBar } from "../FileEditHelpBar";
import { GAME_FONT, GAME_FONT_BOLD } from "../../Constants/Constants";
import TaggedText from "pixi-tagged-text";
import { buttonify } from "../../../engine/HelperFunctions/buttonify";
import { ContactIDtoEmailAddress } from "../../Constants/ContactIDtoEmailAddress";
import { IConversation } from "../../Types/IConversation";
import { LoaderType } from "../../../engine/Loaders/LoaderType";
import { GAME_DEBUG_MODE } from "../../../engine/Constants/Constants";
import { IM22Script } from "../../Types/IM22Script";
import { M22LineType } from "../../Types/M22LineType";
import { TFlagId } from "../../Types/SharedTypes";
import { IM22Line_C } from "../../Types/IM22Line_C";
import { HelperFunctions } from "../../../tsthree";
import { Windows95 } from "../../States/Windows95";
import { NarrativeSingleton } from "../../Logic/NarrativeSingleton";
import { PlayerDataSingleton } from "../../Logic/PlayerDataSingleton";

const width = 322;
const height = 362;

export class Win95MessagingWindow extends Windows95Window {
    private _responseTexts: [Text, Text, Text];
    private _responseTextContainer: Container;
    private _toText: Text;
    private _chatboxText: TaggedText;
    private _selectedResponseGraphic: Graphics;
    private _chatboxBg: NineSlicePlane;
    private _isTypingText: Text;
    private _responseBgGreyedOut: Graphics;

    // private _activeScriptId: TScriptId;
    private _activeConversation: IConversation;
    private _currentLine: number;
    private _selectedFlagsBuffer: TFlagId[] = [];
    private _awaitingDecision: boolean = false;
    private _flagSelection: [TFlagId, TFlagId, TFlagId] = [null, null, null];
    private _currentlySelectedDecision: -1 | 0 | 1 | 2 = -1;

    constructor(_settings: {
        onClose: () => void;
        onMinimise: () => void;
        windowStateRef: IWindowState<Win95MessagingWindow>
    }) {
        super({
            title: "DSN - Summe Guyington",
            iconKey: "stethoscope-dsn",
            dimensions: {
                width: width,
                height: height,
            },
            windowStateRef: _settings.windowStateRef,
            onClose: () => _settings.onClose(),
            onMinimise: () => _settings.onMinimise(),
        });

        const toText = this._toText = new Text("To: Summe Guyington <summeguyington@dsn.com>", new TextStyle({
            fontFamily: GAME_FONT,
            fill: "#000000",
            fontSize: 11,

        }));
        toText.position.set(5, 24);
        this.contentContainer.addChild(toText);

        const chatboxBg = this._chatboxBg = new NineSlicePlane(
            ENGINE.getTexture("inner-container-nineslice")
        );
        chatboxBg.position.set(4, 61);
        chatboxBg.width = width - 8;
        chatboxBg.height = height - 161;
        this.addChild(chatboxBg);
        const chatboxBgMask = new Graphics();
        chatboxBgMask.beginFill(0xff0000, 1);
        chatboxBgMask.drawRect(2, 1, chatboxBg.width - 4, chatboxBg.height - 4);
        chatboxBg.addChild(chatboxBgMask);

        const chatboxText = this._chatboxText = new TaggedText("", {
            default: {
                fill: "#000000",
                fontSize: 11,
                fontFamily: GAME_FONT,
                wordWrap: true,
                wordWrapWidth: chatboxBg.width - 12,
                align: "left",
            },
            contact: {
                fill: "#008080",
            },
            b: {
                fontFamily: GAME_FONT_BOLD,
            }
        });
        chatboxText.mask = chatboxBgMask;
        chatboxText.position.set( 4, 4 );
        chatboxBg.addChild(chatboxText);

        const isTypingText = this._isTypingText = new Text("", new TextStyle({
            fill: "#008080",
            fontSize: 11,
            fontFamily: GAME_FONT,
            wordWrap: true,
            wordWrapWidth: chatboxBg.width - 12,
            align: "left",
        }));
        isTypingText.position.set(4, 4);
        isTypingText.visible = false;
        chatboxText.addChild(isTypingText);

        const responseBg = new NineSlicePlane(
            ENGINE.getTexture("inner-container-nineslice")
        );
        responseBg.position.set(4, chatboxBg.position.y + chatboxBg.height + 2);
        responseBg.width = width - 80;
        responseBg.height = 76;
        this.addChild(responseBg);

        const responseBgGreyedOut = this._responseBgGreyedOut = new Graphics();
        responseBgGreyedOut.beginFill(0x090909, 0.6);
        responseBgGreyedOut.drawRect(2, 1, responseBg.width - 4, responseBg.height - 4);
        responseBgGreyedOut.endFill();
        responseBg.addChild(responseBgGreyedOut);

        const selectedResponse: Graphics = this._selectedResponseGraphic = new Graphics();
        selectedResponse.beginFill(0x0000ff, 1);
        selectedResponse.drawRect(0, 0, responseBg.width - 4, 16);
        selectedResponse.endFill();
        selectedResponse.position.set(1, 1);
        selectedResponse.visible = false;
        responseBg.addChild(selectedResponse);

        const responseTextContainer = this._responseTextContainer = new Container();
        responseBg.addChild(responseTextContainer);

        const responseTextA = new Text(``, new TextStyle({
            fill: "#000000",
            fontSize: 11,
            fontFamily: GAME_FONT,
        }));
        responseTextA.position.set(4,3);
        responseTextContainer.addChild(responseTextA);
        const responseTextB = new Text(``, new TextStyle({
            fill: "#000000",
            fontSize: 11,
            fontFamily: GAME_FONT,
        }));
        responseTextB.position.set(4,3 + responseTextA.height);
        responseTextContainer.addChild(responseTextB);
        const responseTextC = new Text(``, new TextStyle({
            fill: "#000000",
            fontSize: 11,
            fontFamily: GAME_FONT,
        }));
        responseTextC.position.set(4,3 + responseTextB.height + responseTextA.height);
        responseTextContainer.addChild(responseTextC);
        this._responseTexts = [responseTextA, responseTextB, responseTextC];
        buttonify(this._responseTexts, {
            onFire: (ev) => {
                responseTextA.style.fill =
                    responseTextB.style.fill =
                        responseTextC.style.fill = "#000000";

                let i: -1 | 0 | 1 | 2 = -1;
                switch(ev.target) {
                    case responseTextA:
                        i = 0;
                        selectedResponse.position.set(
                            selectedResponse.x,
                            1
                        );
                        responseTextA.style.fill = "#fafafa";
                        break;
                    case responseTextB:
                        i = 1;
                        selectedResponse.position.set(
                            selectedResponse.x,
                            1 + (responseTextA.height)
                        );
                        responseTextB.style.fill = "#fafafa";
                        break;
                    case responseTextC:
                        i = 2;
                        selectedResponse.position.set(
                            selectedResponse.x,
                            1 + (responseTextA.height) + (responseTextB.height)
                        );
                        responseTextC.style.fill = "#fafafa";
                        break;
                }
                this._currentlySelectedDecision = i;
                selectedResponse.visible = true;
            }
        });

        const sendMessageButtonBg = new NineSlicePlane(
            ENGINE.getTexture("generic-square-nineslice")
        );
        sendMessageButtonBg.width = 71;
        sendMessageButtonBg.height = 77;
        sendMessageButtonBg.position.set(
            width - sendMessageButtonBg.width - 4,
            height - sendMessageButtonBg.height - 4 - 18
        );
        this.addChild(sendMessageButtonBg);
        const sendMessageButtonText = new Text("Send", new TextStyle({
            fontFamily: GAME_FONT_BOLD,
            fill: "#000000",
            align: "center",
            fontSize: 14,
        }));
        sendMessageButtonText.anchor.set(0.5, 0.5);
        sendMessageButtonText.position.set(
            Math.round(sendMessageButtonBg.width * 0.5),
            Math.round(sendMessageButtonBg.height * 0.5),
        );
        sendMessageButtonBg.addChild(sendMessageButtonText);
        buttonify(sendMessageButtonBg, {
            onFire: () => this.onSendMessageClicked()
        });

        const fileEditViewText = new FileEditHelpBar([
            {
                name: "File",
                subcontents: [
                    {
                        name: "Exit",
                        onClick: () => {
                            this._onClose();
                        }
                    }
                ]
            },
            {
                name: "View",
                subcontents: [
                    {
                        name: "[placeholder]",
                        onClick: () => {}
                    },
                ]
            },
            {
                name: "Help",
                onClick: () => {}
            },
        ]);
        fileEditViewText.position.set(6, 6 + 18);
        this.addChild(fileEditViewText);
    }

    async executeLine(_line: IM22Line_C, _instant: boolean = false): Promise<void> {
        if(GAME_DEBUG_MODE) console.log(
            `Executing line %i, of type %s. Contents: %s`,
            _line.m_origScriptPos,
            M22LineType[_line.m_lineType],
            _line.m_lineContents
        );
        const nextLine = (): Promise<void> => {
            this._currentLine = this._currentLine + 1;
            if(this._currentLine < json.compiledLines.length) {
                return this.executeLine(
                    (json.compiledLines)[this._currentLine],
                    _instant
                );
            } else {
                this.finishConversation();
            }
        };
        const json = ENGINE.getJSON(
            this._activeConversation.scriptId + "_json"
        ) as IM22Script;
        switch(_line.m_lineType) {
            case M22LineType.NARRATIVE:
                console.warn("M22LineType.NARRATIVE shouldn't exist!");
            // eslint-disable-next-line no-fallthrough
            case M22LineType.DIALOGUE:
                this._isTypingText.text = `${ContactIDtoString[_line.m_speaker?.name]} is typing...`;
                this._isTypingText.visible = true;
                this._isTypingText.position.set(
                    this._isTypingText.x,
                    this._chatboxText.textContainer.height
                );
                if(!_instant) await HelperFunctions.wait(
                    Math.ceil(500 * (_line.m_lineContents.length / 5))
                );
                this.addChatboxText(
                    `<contact>${
                        ContactIDtoString[_line.m_speaker.name]
                    } says:</contact>\n  ${
                        _line.m_lineContents
                    }`
                );
                this._isTypingText.visible = false;
                return nextLine();
            case M22LineType.IF_STATEMENT:
                if(
                    this._selectedFlagsBuffer.indexOf(_line.m_parameters_txt[0]) !== -1
                ) {
                    if(GAME_DEBUG_MODE) {
                        console.log(
                            "Flag %s is true, executing nested function %s",
                            _line.m_parameters_txt[0],
                            M22LineType[_line.m_lineTypeSecondary]
                        );
                    }
                    return this.executeLine(
                        {
                            m_lineContents: null,
                            m_lineType: _line.m_lineTypeSecondary,
                            m_lineTypeSecondary: null,
                            m_parameters_txt: _line.m_parameters_txt.slice(1),
                            m_origScriptPos: _line.m_origScriptPos,
                            m_speaker: _line.m_speaker,
                            m_ID: null,
                            m_parameters: null,
                        },
                        _instant
                    );
                } else {
                    if(GAME_DEBUG_MODE) {
                        console.log(
                            "Flag %s is FALSE, going to next line...",
                            _line.m_parameters_txt[0]
                        );
                    }
                    return nextLine();
                }
            case M22LineType.GOTO:
                if(GAME_DEBUG_MODE) {
                    console.log(
                        "Going to checkpoint %s, line %i (orig pos %i)",
                        _line.m_parameters_txt[0],
                        json.checkpoints[_line.m_parameters_txt[0]],
                        json.compiledLines[
                            json.checkpoints[_line.m_parameters_txt[0]]
                        ].m_origScriptPos
                    );
                }
                this._currentLine = json.checkpoints[_line.m_parameters_txt[0]];
                return this.executeLine(
                    json.compiledLines[this._currentLine],
                    _instant
                );
            case M22LineType.WAIT:
                if(!_instant) await HelperFunctions.wait(_line.m_parameters[0]);
                return nextLine();
            case M22LineType.MAKE_DECISION:
                this._flagSelection = [null, null, null];
                const firstChoice = _line.m_parameters_txt[0];
                const firstChoiceFlag = _line.m_parameters_txt[1];
                const secondChoice = _line.m_parameters_txt[2];
                const secondChoiceFlag = _line.m_parameters_txt[3];
                const thirdChoice = _line.m_parameters_txt[4];
                const thirdChoiceFlag = _line.m_parameters_txt[5];

                if(
                    NarrativeSingleton.hasFlag(firstChoiceFlag) ||
                    NarrativeSingleton.hasFlag(secondChoiceFlag) ||
                    NarrativeSingleton.hasFlag(thirdChoiceFlag)
                ) {
                    return nextLine();
                }

                this._responseBgGreyedOut.visible = false;

                this._responseTexts[0].text = `1. "${firstChoice}"`;
                this._responseTexts[0].visible = true;
                this._flagSelection[0] = firstChoiceFlag;
                if(secondChoice) {
                    this._responseTexts[1].text = `2. "${secondChoice}"`;
                    this._responseTexts[1].visible = true;
                    this._flagSelection[1] = secondChoiceFlag;
                }
                if(thirdChoice) {
                    this._responseTexts[2].text = `3. "${thirdChoice}"`;
                    this._responseTexts[2].visible = true;
                    this._flagSelection[2] = thirdChoiceFlag;
                }
                this._awaitingDecision = true;
                break;
            case M22LineType.CHECKPOINT:
                return nextLine();
            default:
                console.warn(
                    "No functionality for type %s",
                    M22LineType[_line.m_lineType]
                );
                break;
        }
    }

    addChatboxText(_str: string): void {
        this._chatboxText.text += _str;
        if(
            this._chatboxText.textContainer.height > (this._chatboxBg.height - 24)
        ) {
            this._chatboxText.position.set(
                this._chatboxText.x,
                4 - (this._chatboxText.textContainer.height - this._chatboxBg.height) - 24
            );
        }
    }

    onSendMessageClicked(): void {
        if(!this._awaitingDecision || this._currentlySelectedDecision === -1) return;

        if(GAME_DEBUG_MODE) {
            console.log("Making decision %s", this._flagSelection[this._currentlySelectedDecision]);
        }
        this._responseBgGreyedOut.visible = true;

        this._selectedFlagsBuffer.push(
            this._flagSelection[this._currentlySelectedDecision]
        );

        NarrativeSingleton.addFlag(this._flagSelection[this._currentlySelectedDecision]);

        this.addChatboxText(`<contact>You say:</contact>\n  <b>${
            this._responseTexts[this._currentlySelectedDecision].text
                .substring(4, this._responseTexts[this._currentlySelectedDecision].text.length - 1)
        }</b>\n`);
        this._responseTexts.forEach((e) => (e.text = "", e.visible = false));
        this._awaitingDecision = false;
        this._selectedResponseGraphic.visible = false;
        this._currentlySelectedDecision = -1;
        this._flagSelection = [null, null, null];
        const json: IM22Script = ENGINE.getJSON(this._activeConversation.scriptId + "_json");
        // let promiseChain: Promise<void> = Promise.resolve();

        this._currentLine++;

        HelperFunctions.wait(1000).then(() =>
            this.executeLine(json.compiledLines[this._currentLine])
        );
    }

    finishConversation() {
        alert("Finishing conversation");
        NarrativeSingleton.finishConversation(this._activeConversation);
        // (ENGINE.getActiveState() as Windows95)
        //     .updateContacts();
    }

    update(
        _contactStatus: IContactStatus,
        _conversation: IConversation,
        _isSeen: boolean = false
    ): void {
        this._title.text = `${ContactIDtoString[_contactStatus.id]} - Instant Messaging`;

        this._chatboxText.position.set(4, 4);
        this._chatboxText.text = "Loading chat...";

        this._title.text = "DSN - " + ContactIDtoString[_contactStatus.id];

        this._responseTexts[0].position.set(4,3);
        this._responseTexts[1].position.set(4,3 + this._responseTexts[0].height);
        this._responseTexts[2].position.set(4,3 + this._responseTexts[1].height + this._responseTexts[0].height);
        this._toText.text = `To: ${ContactIDtoString[_contactStatus.id]} <${ContactIDtoEmailAddress[_contactStatus.id]}>`;
        this._responseTexts.forEach((e) => (e.text = "", e.visible = false));

        this._activeConversation = _conversation;
        const jsonAssetId = _conversation.scriptId + "_json";
        let promise: Promise<void>;
        const fakeTimer = 800;
        if(!ENGINE.hasJSON(jsonAssetId)) {
            if(GAME_DEBUG_MODE) {
                console.log("Loading json %s", jsonAssetId);
            }
            promise =
                (ENGINE.loadAssets([{
                    key: jsonAssetId,
                    path: `data/Conversations/${_contactStatus.id}/${_conversation.scriptId}.json`,
                    type: LoaderType.JSON
                }])
                    .then(() => {
                        return new Promise((res, rej) => {
                            setTimeout(() => res(), fakeTimer);
                        });
                    }));
        } else {
            if(GAME_DEBUG_MODE) {
                console.log("JSON %s already loaded", jsonAssetId);
            }
            promise = new Promise((res, rej) => {
                setTimeout(() => res(), fakeTimer);
            });
        }
        promise.then((e) => {
            const json: IM22Script = ENGINE.getJSON(jsonAssetId);
            if(GAME_DEBUG_MODE) {
                console.log(json);
            }
            let str = "";
            let counter = 0;
            for (let i = 0; i < json.compiledLines.length; i++, counter = i) {
                if(json.compiledLines[i].m_lineType !== M22LineType.DIALOGUE)
                    break;
                str += `<contact>${ContactIDtoString[_contactStatus.id]} says:</contact>\n  ${
                    json.compiledLines[i].m_lineContents
                }`;
            }
            this._chatboxText.text = str;
            this._currentLine = counter;
            this.executeLine(json.compiledLines[this._currentLine], _isSeen);
        });
    }
}